package com.kinoshazam.uiKit.theme

import androidx.compose.foundation.isSystemInDarkTheme
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Shapes
import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.ReadOnlyComposable
import androidx.compose.runtime.mutableStateOf
import androidx.compose.ui.graphics.Color
import com.kinoshazam.LocalAppLocale
import com.kinoshazam.LocalLocalization
import com.kinoshazam.model.AppLanguage
import com.kinoshazam.model.ThemeState
import com.kinoshazam.uiKit.config.LocalFormFactor
import com.kinoshazam.uiKit.config.uiKitFormFactor
import com.kinoshazam.uiKit.theme.colors.DarkColorPalette
import com.kinoshazam.uiKit.theme.colors.LightColorPalette
import com.kinoshazam.uiKit.theme.colors.LocalUiKitColors
import com.kinoshazam.uiKit.theme.colors.UiKitColors
import utils.FormFactor


//private val LightColors = lightColors(
//    primary = md_theme_light_primary,
//    onPrimary = md_theme_light_onPrimary,
//    secondary = md_theme_light_secondary,
//    onSecondary = md_theme_light_onSecondary,
//    error = md_theme_light_error,
//    onError = md_theme_light_onError,
//    background = md_theme_light_background,
//    onBackground = md_theme_light_onBackground,
//    surface = md_theme_light_surface,
//    onSurface = md_theme_light_onSurface,
//)
//
//
//private val DarkColors = darkColors(
//    primary = md_theme_dark_primary,
//    onPrimary = md_theme_dark_onPrimary,
//    secondary = md_theme_dark_secondary,
//    onSecondary = md_theme_dark_onSecondary,
//    error = md_theme_dark_error,
//    onError = md_theme_dark_onError,
//    background = md_theme_dark_background,
//    onBackground = md_theme_dark_onBackground,
//    surface = md_theme_dark_surface,
//    onSurface = md_theme_dark_onSurface,
//)

@Composable
fun UiKitTheme(
    darkTheme: Boolean = isUiKitInDarkTheme(),
    dynamicColor: Boolean = false, // for material 3
    content: @Composable() () -> Unit
) {
    val colors = if (darkTheme) DarkColorPalette else LightColorPalette

    SetStatusBarColor(Color.Transparent, darkIcons = !darkTheme)

    ProviderCompositionLocal(
        uiKitColors = colors,
        formFactor = uiKitFormFactor.value,
    ) {
        MaterialTheme(
//            colors = colors, TODO: ???
            typography = typography,
            shapes = Shapes(),
            content = content
        )
    }
}

@Composable
internal fun ProviderCompositionLocal(
    uiKitColors: UiKitColors,
    formFactor: FormFactor,
    content: @Composable () -> Unit
) {
    val language = uiKitLocalizationState.value
    // Sets window.__customLocale (web) before children read Locale.current.
    CompositionLocalProvider(
        LocalUiKitColors provides uiKitColors,
        LocalFormFactor provides formFactor,
        LocalLocalization provides language,
        LocalAppLocale provides language.locale,
    ) {
        content()
    }
}

object UiKitTheme { //: RippleTheme {

    val colors: UiKitColors
        @Composable
        @ReadOnlyComposable
        get() = LocalUiKitColors.current

//    val gradients: UiKitColorsGradients
//        @Composable @ReadOnlyComposable get() = LocalUiKitGradients.current

//    @Composable
//    override fun defaultColor(): Color {
//        return colors.color_6
//    }
//
//    @Composable
//    override fun rippleAlpha(): RippleAlpha {
//        val alpha = 0.5f
//        return RippleAlpha(
//            alpha,
//            alpha,
//            alpha,
//            alpha,
//        )
//    }
}

@Composable
fun isUiKitInDarkTheme(): Boolean {
    return when (uiKitThemeState.value) {
        ThemeState.SYSTEM -> isSystemInDarkTheme()
        ThemeState.DARK -> true
        ThemeState.LIGHT -> false
    }
}

// TODO: change to ThemeState.SYSTEM then settings will done
val uiKitThemeState = mutableStateOf(ThemeState.DARK)

val uiKitLocalizationState = mutableStateOf(AppLanguage.EN)
